import { updateLinkColors as e } from "./utils/update-link-colors.mjs";
import { useEffect as t } from "react";
//#region src/extensions/link-extension/use-update-link-color.ts
var n = (n, r) => {
	t(() => {
		n && r && e(n, r);
	}, [r, n]);
};
//#endregion
export { n as useUpdateLinkColor };
